import { CloserLocationsApi } from '../../api'
import { setCloserLocations, setCloserLocationsLoading } from '../../actions'

export const fetchCloserLocations = (params) => {
  return async (dispatch) => {
    dispatch(setCloserLocationsLoading(true))

    const api = new CloserLocationsApi()
    const closerLocations = await api.getCloserLocations(params)

    dispatch(setCloserLocations(closerLocations))
    dispatch(setCloserLocationsLoading(false))
  }
}
